import { ERRORS as STT_ERRORS } from '../sttSocket';

export enum PRONUNCIATION_ERRORS {
  NO_USER_ID = `No user id found`,
}

export const ERRORS = { ...STT_ERRORS, ...PRONUNCIATION_ERRORS };
